export default "__VITE_ASSET__Clr1dieC__"